export const USER_KEY = 'info';

export const LOCAL_STORAGE_KEYS = {
  like: '_like',
  dislike: '_dislike',
  activeButton: '_activeButton',
};
